import { Injectable } from '@angular/core';
import { TimeagoFormatter } from 'ngx-timeago';

const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;
const MONTH = DAY * 30;
const YEAR = DAY * 365;

@Injectable()
export class TimeagoShortFormatter extends TimeagoFormatter {
  format(then: number): string {
    const seconds = Math.round(Math.abs(Date.now() - then) / 1000);

    if (seconds < MINUTE) return 'just now';
    if (seconds < HOUR) return Math.round(seconds / MINUTE) + 'm';
    if (seconds < DAY) return Math.round(seconds / HOUR) + 'h';
    if (seconds < WEEK) return Math.round(seconds / DAY) + 'd';
    if (seconds < MONTH) return Math.round(seconds / WEEK) + 'w';
    if (seconds < YEAR) return Math.round(seconds / MONTH) + 'mo';
    return Math.round(seconds / YEAR) + 'y';
  }
}
